/**
 * Composant pour afficher les champs d'un événement
 * @module admin/components/EventFields
 */

import React from 'react';
import PropTypes from 'prop-types';
import { eventFieldsConfig } from '../constants/eventFieldsConfig';

/**
 * Composant d'affichage des champs d'événement
 * @param {Object} props
 * @param {string} props.selectedEvent - Type d'événement sélectionné
 * @param {Object} props.eventOptions - Options de l'événement
 * @param {function} props.onOptionChange - Fonction appelée lors du changement d'une option
 * @returns {JSX.Element}
 */
const EventFields = ({ selectedEvent, eventOptions, onOptionChange }) => {
  const fields = eventFieldsConfig[selectedEvent];
  
  if (!fields) {
    return (
      <p className="admin-info">
        Aucune option spécifique pour cet événement.
      </p>
    );
  }

  return (
    <div className="admin-event-fields">
      {fields.map((field) => (
        <div key={field.name} className="admin-field">
          <label htmlFor={field.name}>{field.label}</label>
          {field.type === 'select' ? (
            <select
              id={field.name}
              value={eventOptions[field.name] || ''}
              onChange={(e) => onOptionChange(field.name, e.target.value)}
            >
              <option value="">Sélectionner...</option>
              {field.options.map((opt) => (
                <option key={opt} value={opt}>
                  {field.optionLabels && field.optionLabels[opt]
                    ? field.optionLabels[opt]
                    : opt}
                </option>
              ))}
            </select>
          ) : field.type === 'checkbox' ? (
            <input
              type="checkbox"
              id={field.name}
              checked={eventOptions[field.name] || false}
              onChange={(e) => onOptionChange(field.name, e.target.checked)}
            />
          ) : (
            <input
              type={field.type}
              id={field.name}
              value={eventOptions[field.name] || ''}
              placeholder={field.placeholder}
              min={field.min}
              max={field.max}
              onChange={(e) => onOptionChange(field.name, e.target.value)}
            />
          )}
        </div>
      ))}
    </div>
  );
};

EventFields.propTypes = {
  selectedEvent: PropTypes.string.isRequired,
  eventOptions: PropTypes.object.isRequired,
  onOptionChange: PropTypes.func.isRequired,
};

export default EventFields;
